import { render, staticRenderFns } from "./special-gifts-solutions.vue?vue&type=template&id=d1c7ed64"
import script from "./special-gifts-solutions.vue?vue&type=script&lang=js"
export * from "./special-gifts-solutions.vue?vue&type=script&lang=js"
import style0 from "./special-gifts-solutions.vue?vue&type=style&index=0&id=d1c7ed64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
